import styled from "styled-components";

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  position: absolute;
  right: 15px;
  top: 15px;
`;
